import {useBufferResponseEffect} from "../internal/use-buffer-response-effect.ts";
import {useGuideAppearanceSyncEffect} from "../internal/use-guide-appearance-sync-effect.ts";
import {useNavigationEffect} from "../internal/use-navigation-effect.ts";
import {usePollCooldownStatus} from "../internal/use-poll-cooldown-status.ts";
import {useRetryTimeoutSideEffect} from "../internal/use-retry-timeout-side-effect.ts";
import {useUpdateTermsAcknowledgementEffect} from "../internal/use-update-terms-acknowledgement-effect.ts";

/**
 * Various effects that sync guide state with page navigation and settings.
 */
export const useGuideStateSyncEffect = (): void => {
    // Update our state with the latest terms acknowledgement status.
    useUpdateTermsAcknowledgementEffect();

    // Keep buffer/streaming setting in sync with reduce motion setting
    useBufferResponseEffect();

    // Keep selected appearance in sync with state.
    useGuideAppearanceSyncEffect();

    // Handle retryCountdownSeconds countdown
    useRetryTimeoutSideEffect();

    // Handle page navigation
    useNavigationEffect();

    // Handle polling for cooldown status updates
    usePollCooldownStatus();
};
